/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalAgreementEventTimelinePayload
 */
export interface LegalAgreementEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof LegalAgreementEventTimelinePayload
     */
    acceptanceId: string;
    /**
     * 
     * @type {string}
     * @memberof LegalAgreementEventTimelinePayload
     */
    agreementType: string;
    /**
     * 
     * @type {number}
     * @memberof LegalAgreementEventTimelinePayload
     */
    versionNumber: number;
    /**
     * Link to the stored signed PDF, absent until the document is available.
     * @type {string}
     * @memberof LegalAgreementEventTimelinePayload
     */
    signedDocumentUrl?: string;
}

/**
 * Check if a given object implements the LegalAgreementEventTimelinePayload interface.
 */
export function instanceOfLegalAgreementEventTimelinePayload(value: object): value is LegalAgreementEventTimelinePayload {
    if (!('acceptanceId' in value) || value['acceptanceId'] === undefined) return false;
    if (!('agreementType' in value) || value['agreementType'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    return true;
}

export function LegalAgreementEventTimelinePayloadFromJSON(json: any): LegalAgreementEventTimelinePayload {
    return LegalAgreementEventTimelinePayloadFromJSONTyped(json, false);
}

export function LegalAgreementEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'acceptanceId': json['acceptanceId'],
        'agreementType': json['agreementType'],
        'versionNumber': json['versionNumber'],
        'signedDocumentUrl': json['signedDocumentUrl'] == null ? undefined : json['signedDocumentUrl'],
    };
}

export function LegalAgreementEventTimelinePayloadToJSON(value?: LegalAgreementEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'acceptanceId': value['acceptanceId'],
        'agreementType': value['agreementType'],
        'versionNumber': value['versionNumber'],
        'signedDocumentUrl': value['signedDocumentUrl'],
    };
}

